/* POSH — السلة والتوصيل:
   0) window.poshMoney(cents): تنسيق السعر حسب عملة سوق العميل
   1) يجمّع أسطر البكج + سعر القطعة في البكج بعملة العميل
   2) window.poshAfterAdd(): بعد أي إضافة → يعيد رسم السلة الجانبية ويفتحها
   3) شريط السلة (مختصر): عرض الشماغين + تقدّم الشحن المجاني (40 د.ك) + اقتراح واحد + تاريخ التوصيل
      — بيتحط جوه منطقة المنتجات اللي بتعمل scroll عشان ما ياكلش مساحة السلة على الموبايل
   4) تاريخ التوصيل التقديري: "يوصلك بحلول الخميس 24 سبتمبر" (صفحة المنتج + البكج + صفحة العرض + السلة)
   ستايل صفوف السلة والخلفية في posh-cart.css */
(function () {
  'use strict';

  /* ---------- 0) العملة ---------- */
  var CUR_LABEL = { KWD: 'د.ك', SAR: 'ر.س', AED: 'د.إ', BHD: 'د.ب', QAR: 'ر.ق', OMR: 'ر.ع', EGP: 'ج.م', USD: '$' };
  var THREE_DEC = { KWD: 1, BHD: 1, OMR: 1, JOD: 1, IQD: 1, LYD: 1, TND: 1 };
  function currentCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'KWD';
  }
  function currencyRate() {
    var r = window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate);
    return r && r > 0 ? r : 1;
  }
  function poshMoney(cents) {
    var cur = currentCurrency();
    var dec = THREE_DEC[cur] ? 3 : 2;
    var n = (Number(cents || 0) / 100).toFixed(dec);
    /* 22.500 → 22.5 و 18.000 → 18 */
    if (n.indexOf('.') > -1) n = n.replace(/0+$/, '').replace(/\.$/, '');
    return n + ' ' + (CUR_LABEL[cur] || cur);
  }
  window.poshMoney = poshMoney;
  window.poshCurrency = currentCurrency;

  var perFixed = false;
  function fixBundlePerPiece() {
    if (perFixed || currentCurrency() === 'KWD') return;
    var root = document.querySelector('[data-bundle]');
    var el = root && root.querySelector('.posh-bundle__per b');
    if (!el) return;
    perFixed = true;
    var path = location.pathname.split('?')[0];
    if (path.charAt(path.length - 1) === '/') path = path.slice(0, -1);
    fetch(path + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var slots = parseInt(root.dataset.slots, 10) || 4;
      el.textContent = poshMoney(Math.round(p.price / slots));
    }).catch(function () { el.parentElement.hidden = true; });
  }

  /* ---------- 4) تاريخ التوصيل التقديري ---------- */
  var DELIVERY = {
    cutoffHour: 14,            /* الطلب بعد 2 الظهر (بتوقيت الخليج) يبدأ من يوم العمل التالي */
    offDays: [5],              /* الجمعة إجازة شركات الشحن */
    KW: { days: 2 },
    SA: [
      { label: 'الرياض', days: 1 },
      { label: 'المدن الرئيسية', days: 3 },
      { label: 'المناطق البعيدة', days: 5 }
    ]
  };

  function gulfNow() {
    var n = new Date();
    return new Date(n.getTime() + (n.getTimezoneOffset() + 180) * 60000);
  }
  function isOff(d) { return DELIVERY.offDays.indexOf(d.getDay()) > -1; }
  function startDay() {
    var now = gulfNow();
    var s = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    if (now.getHours() >= DELIVERY.cutoffHour || isOff(s)) {
      do { s.setDate(s.getDate() + 1); } while (isOff(s));
    }
    return s;
  }
  function addBusinessDays(n) {
    var d = startDay();
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      if (!isOff(d)) added++;
    }
    return d;
  }
  function fmtDate(d) {
    try {
      return new Intl.DateTimeFormat('ar-u-ca-gregory-nu-latn', { weekday: 'long', day: 'numeric', month: 'long' }).format(d).replace('،', '');
    } catch (e) {
      return d.toLocaleDateString();
    }
  }
  function etaHtml() {
    var c = (window.Shopify && window.Shopify.country) || '';
    if (c === 'KW') {
      return '<span>🚚 يوصلك بحلول <b>' + fmtDate(addBusinessDays(DELIVERY.KW.days)) + '</b></span>';
    }
    if (c === 'SA') {
      var r = DELIVERY.SA;
      return '<span>🚚 ' + r[0].label + ': <b>' + fmtDate(addBusinessDays(r[0].days)) + '</b> · ' + r[1].label + ': <b>' + fmtDate(addBusinessDays(r[1].days)) + '</b></span>' +
        '<small>' + r[2].label + ' بحلول ' + fmtDate(addBusinessDays(r[2].days)) + '</small>';
    }
    return '';
  }
  window.poshEta = etaHtml;

  /* نسخة سطر واحد للسلة */
  function etaShort() {
    var c = (window.Shopify && window.Shopify.country) || '';
    if (c === 'KW') return 'يوصلك بحلول <b>' + fmtDate(addBusinessDays(DELIVERY.KW.days)) + '</b>';
    if (c === 'SA') return DELIVERY.SA[0].label + ' بحلول <b>' + fmtDate(addBusinessDays(DELIVERY.SA[0].days)) + '</b> · باقي المدن ' + DELIVERY.SA[1].days + '–' + DELIVERY.SA[2].days + ' أيام عمل';
    return '';
  }

  function makeEta(extraClass) {
    var html = etaHtml();
    if (!html) return null;
    var el = document.createElement('div');
    el.className = 'posh-eta' + (extraClass ? ' ' + extraClass : '');
    el.dataset.poshEta = '1';
    el.innerHTML = html;
    return el;
  }

  function placeEta() {
    injectStyle();
    /* صفحة المنتج */
    var form = document.querySelector('.posh-pd__info form[action*="/cart/add"]');
    if (form && !form.parentElement.querySelector('[data-posh-eta]')) {
      var e1 = makeEta();
      if (e1) form.insertAdjacentElement('afterend', e1);
    }
    /* صفحة البكج */
    var bundle = document.querySelector('[data-bundle]');
    var per = bundle && bundle.querySelector('.posh-bundle__per');
    if (per && !bundle.querySelector('[data-posh-eta]')) {
      var e2 = makeEta('posh-eta--inline');
      if (e2) per.insertAdjacentElement('afterend', e2);
    }
    /* صفحة طقم الشماغين */
    var summary = document.querySelector('.posh-po__summary');
    if (summary && !summary.querySelector('[data-posh-eta]')) {
      var e3 = makeEta('posh-eta--inline');
      var note = summary.querySelector('.posh-po__note');
      if (e3) summary.insertBefore(e3, note || null);
    }
  }

  /* ---------- 1) تجميع أسطر البكج ---------- */
  var PROP = 'بكج بوش';
  var STAMP = /BOX-[0-9]{10,}/;
  var LABEL = 'بكج بوش الخشبي الفاخر';
  var GIFT = '◆ الصندوق الخشبي هدية';
  var ROW_SELECTORS = ['.cart-items__table-row', '.cart-item', 'tr[data-line-item]', 'li[id^="cart-product"]'].join(',');

  function stampOf(row) {
    var text = row.textContent || '';
    if (text.indexOf(PROP) === -1) return null;
    var m = text.match(STAMP);
    return m ? m[0] : null;
  }

  function groupBundles() {
    var rows = Array.prototype.slice.call(document.querySelectorAll(ROW_SELECTORS));
    if (!rows.length) return;
    var groups = {};
    rows.forEach(function (row) {
      row.classList.remove('posh-bundlerow', 'posh-bundlerow--first', 'posh-bundlerow--last');
      var stamp = stampOf(row);
      if (!stamp) return;
      row.classList.add('posh-bundlerow');
      (groups[stamp] = groups[stamp] || []).push(row);
    });
    Object.keys(groups).forEach(function (stamp) {
      var list = groups[stamp];
      list[0].classList.add('posh-bundlerow--first');
      list[0].dataset.poshLabel = LABEL;
      list[list.length - 1].classList.add('posh-bundlerow--last');
      list[list.length - 1].dataset.poshGift = GIFT;
    });
  }

  /* ---------- 2) بعد الإضافة ---------- */
  function findDrawer() {
    return document.querySelector('theme-drawer#cart-drawer') || document.querySelector('theme-drawer[id*="cart"]');
  }

  async function redrawDrawer(drawer) {
    var host = drawer.closest('[id^="shopify-section-"]');
    if (!host) return false;
    var sectionId = host.id.replace('shopify-section-', '');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var res = await fetch(root + '?sections=' + encodeURIComponent(sectionId));
    if (!res.ok) return false;
    var json = await res.json();
    var html = json[sectionId];
    if (!html) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('cart-drawer-component');
    var cur = drawer.querySelector('cart-drawer-component');
    if (!fresh || !cur) return false;
    cur.innerHTML = fresh.innerHTML;
    return true;
  }

  async function afterAdd() {
    var drawer = findDrawer();
    if (!drawer || typeof drawer.open !== 'function') { location.href = '/cart'; return; }
    try {
      var cart = await (await fetch('/cart.js')).json();
      var ok = await redrawDrawer(drawer);
      if (!ok) { location.href = '/cart'; return; }
      document.querySelectorAll('.cart-bubble__text-count, [data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, sourceId: 'posh', data: { source: 'posh', itemCount: cart.item_count, didError: false } }
      }));
      drawer.open();
      setTimeout(function () { refreshOffer(true); }, 300);
    } catch (e) {
      location.href = '/cart';
    }
  }
  window.poshAfterAdd = afterAdd;

  /* ---------- 3) شريط السلة ---------- */
  var OFFER = {
    type: 'شماغ',
    min: 2,
    pct: 20,
    freeShip: 4000,
    ghutraHandle: 'غترة-بوش',
    serviceHandle: 'شماغك-جاهز',
    shopUrl: '/pages/offer'
  };

  var HOSTS = ['cart-items-component', '.cart-items-component', '.cart-page__items'];
  /* منطقة المنتجات اللي بتعمل scroll — الشريط يتحط فيها عشان ما يثبتش فوق */
  var SCROLLERS = ['.cart-drawer__items', '.cart-page__items'];

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
  function complement(handle) {
    if (!handle) return null;
    if (handle.indexOf('أحمر') > -1) return handle.replace('أحمر', 'أبيض');
    if (handle.indexOf('أبيض') > -1) return handle.replace('أبيض', 'أحمر');
    return null;
  }

  function injectStyle() {
    if (document.getElementById('posh-offerbar-css')) return;
    var s = document.createElement('style');
    s.id = 'posh-offerbar-css';
    s.textContent = [
      /* الشريط المختصر */
      '.posh-offerbar{flex-shrink:0;margin:4px 0 12px;padding:10px 12px;border-radius:12px;background:#fffdf8;border:1px solid rgb(201 164 73/.5);font-family:inherit;text-align:start;display:grid;gap:8px}',
      '.posh-offerbar--done{background:#f6faf6;border-color:#d3e6d8}',
      '.posh-ob__head{display:flex;align-items:center;justify-content:space-between;gap:8px;font-size:13.5px;line-height:1.45}',
      '.posh-ob__head b{font-weight:800;color:#800020}',
      '.posh-offerbar--done .posh-ob__head b{color:#1e6b34}',
      '.posh-ob__head a{flex-shrink:0;font-size:12.5px;font-weight:700;color:#800020;text-decoration:underline;text-underline-offset:3px;white-space:nowrap}',
      '.posh-ob__pick{display:flex;align-items:center;gap:10px;padding:6px;border-radius:10px;background:#fff;border:1px solid #efe6d4}',
      '.posh-ob__pick img{width:38px;height:46px;object-fit:cover;border-radius:6px;flex-shrink:0;background:#efe2cc}',
      '.posh-ob__meta{flex:1;min-width:0;display:flex;flex-direction:column;gap:1px;line-height:1.35}',
      '.posh-ob__meta b{font-size:12.5px;font-weight:700;color:#1f1a16;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
      '.posh-ob__meta span{font-size:12.5px;font-weight:800;color:#800020;unicode-bidi:isolate}',
      '.posh-ob__meta s{margin-inline-start:6px;font-weight:400;color:#9a8f80}',
      '.posh-ob__add{flex-shrink:0;min-height:36px;padding:0 14px;border:0;border-radius:9px;background:#800020;color:#f5f5dc;font-family:inherit;font-size:13px;font-weight:800;cursor:pointer}',
      '.posh-ob__add[disabled]{opacity:.6}',
      '.posh-ob__cross{display:flex;align-items:center;justify-content:space-between;gap:8px;padding:8px 10px;border-radius:10px;background:#fff;border:1px solid #efe6d4;color:#1f1a16;font-size:12.5px;font-weight:700;line-height:1.4;text-decoration:none}',
      '.posh-ob__cross em{font-style:normal;color:#800020;white-space:nowrap;unicode-bidi:isolate}',
      '.posh-ob__ship{font-size:12.5px;font-weight:700;line-height:1.5;color:#3d3730}',
      '.posh-ob__ship b{color:#800020;unicode-bidi:isolate}',
      '.posh-ob__ship.is-free{color:#1e6b34}',
      '.posh-ob__track{height:3px;margin-top:5px;border-radius:999px;background:#efe3c7;overflow:hidden}',
      '.posh-ob__track i{display:block;height:100%;border-radius:999px;background:#b8962e;transition:width .4s ease}',
      '.posh-ob__eta{font-size:12px;font-weight:600;line-height:1.5;color:#2f5a3a}',
      '.posh-ob__eta b{font-weight:800}',
      /* تاريخ التوصيل في صفحات المنتج */
      '.posh-eta{display:flex;flex-direction:column;gap:3px;margin-top:12px;padding:10px 12px;border-radius:12px;background:#f3f8f3;border:1px solid #d6e8da;font-family:inherit;font-size:13.5px;font-weight:700;line-height:1.7;color:#2f3d33;text-align:start}',
      '.posh-eta b{color:#1e6b34}',
      '.posh-eta small{font-size:12px;font-weight:600;color:#5d6d61}',
      '.posh-eta--inline{margin:10px 0 0}'
    ].join('');
    document.head.appendChild(s);
  }

  async function productJson(handle) {
    try {
      var r = await fetch('/products/' + encodeURIComponent(handle) + '.js');
      return r.ok ? r.json() : null;
    } catch (e) { return null; }
  }

  async function addFromBanner(id, btn) {
    if (btn) { btn.disabled = true; btn.textContent = '...'; }
    try {
      var r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) });
      if (!r.ok) throw new Error();
      if (location.pathname.indexOf('/cart') === 0) { location.reload(); return; }
      afterAdd();
    } catch (e) { if (btn) { btn.disabled = false; btn.textContent = 'أضف'; } }
  }

  function shipState(cart) {
    var sub = cart.items.reduce(function (s, i) { return i.handle === OFFER.serviceHandle ? s : s + i.final_line_price; }, 0);
    var threshold = Math.round(OFFER.freeShip * currencyRate());
    return { sub: sub, threshold: threshold, remaining: Math.max(0, threshold - sub) };
  }

  function shipHtml(st) {
    if (!st.sub) return '';
    var eta = etaShort();
    var etaLine = eta ? '<div class="posh-ob__eta">🚚 ' + eta + '</div>' : '';
    if (st.remaining <= 0) return '<div class="posh-ob__ship is-free">✓ شحنك مجاني</div>' + etaLine;
    var pct = Math.min(100, Math.round(st.sub / st.threshold * 100));
    return '<div class="posh-ob__ship">باقي <b>' + poshMoney(st.remaining) + '</b> وشحنك مجاني' +
      '<div class="posh-ob__track"><i style="width:' + pct + '%"></i></div></div>' + etaLine;
  }

  async function buildBanner(cart) {
    var lines = cart.items.filter(function (i) { return i.product_type === OFFER.type; });
    var qty = lines.reduce(function (s, i) { return s + i.quantity; }, 0);
    var st = shipState(cart);

    var box = document.createElement('div');
    box.className = 'posh-offerbar';
    box.dataset.poshOffer = '1';

    /* مفيش شماغ: شحن + توصيل بس */
    if (!qty) {
      var only = shipHtml(st);
      if (!only) return null;
      if (st.remaining <= 0) box.classList.add('posh-offerbar--done');
      box.innerHTML = only;
      return box;
    }

    /* شماغ واحد: اقتراح الشماغ الثاني */
    if (qty < OFFER.min) {
      var line = lines[0];
      var html = '<div class="posh-ob__head"><b>أضف شماغ ثاني ووفّر ' + OFFER.pct + '%</b><a href="' + OFFER.shopUrl + '">كل الشماغات ←</a></div>';
      var compHandle = complement(line.handle);
      var comp = compHandle ? await productJson(compHandle) : null;
      if (comp) {
        var v = comp.variants.find(function (x) { return x.title === line.variant_title && x.available; }) || comp.variants.find(function (x) { return x.available; });
        if (v) {
          var after = Math.round(v.price * (100 - OFFER.pct) / 100);
          var img = comp.featured_image ? comp.featured_image + (comp.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=100' : '';
          html += '<div class="posh-ob__pick">' +
            (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') +
            '<div class="posh-ob__meta"><b>' + esc(comp.title) + ' · مقاس ' + esc(v.title) + '</b><span>' + poshMoney(after) + '<s>' + poshMoney(v.price) + '</s></span></div>' +
            '<button type="button" class="posh-ob__add" data-id="' + v.id + '">أضف</button></div>';
        }
      }
      html += shipHtml(st);
      box.innerHTML = html;
      var btn = box.querySelector('.posh-ob__add');
      if (btn) btn.addEventListener('click', function () { addFromBanner(Number(btn.dataset.id), btn); });
      return box;
    }

    /* شماغين أو أكثر: الخصم متفعّل + اقتراح واحد بس */
    box.classList.add('posh-offerbar--done');
    var saved = lines.reduce(function (s, i) { return s + (i.original_line_price - i.final_line_price); }, 0);
    var html2 = '<div class="posh-ob__head"><b>✓ خصم الطقم متفعّل' + (saved > 0 ? ' · وفّرت ' + poshMoney(saved) : '') + '</b></div>';

    var cross = '';
    var country = (window.Shopify && window.Shopify.country) || '';
    var hasGhutra = cart.items.some(function (i) { return i.handle === OFFER.ghutraHandle; });
    var hasService = cart.items.some(function (i) { return i.handle === OFFER.serviceHandle; });
    var gh = hasGhutra ? null : await productJson(OFFER.ghutraHandle);
    var unlocks = gh && st.remaining > 0 && gh.price >= st.remaining;
    if (gh && (unlocks || country !== 'KW' || hasService)) {
      cross = '<a class="posh-ob__cross" href="' + esc(gh.url) + '"><span>' + (unlocks ? 'أضف غترة بوش وخذ شحن مجاني' : 'كمّلها بغترة بوش') + '</span><em>' + poshMoney(gh.price) + ' ←</em></a>';
    } else if (country === 'KW' && !hasService) {
      cross = '<a class="posh-ob__cross" href="/products/' + encodeURIComponent(OFFER.serviceHandle) + '"><span>مناسبة قريبة؟ يوصلك مكوي خلال ساعتين</span><em>شماغك جاهز ←</em></a>';
    }

    html2 += cross + shipHtml(st);
    box.innerHTML = html2;
    return box;
  }

  function slotFor(host) {
    for (var i = 0; i < SCROLLERS.length; i++) {
      if (host.matches(SCROLLERS[i])) return host;
      var s = host.querySelector(SCROLLERS[i]);
      if (s) return s;
    }
    return host;
  }

  var lastSig = '';
  var busy = false;

  async function refreshOffer(force) {
    if (busy) return;
    var hosts = [];
    HOSTS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (h) {
        if (hosts.indexOf(h) === -1 && !hosts.some(function (x) { return x.contains(h) || h.contains(x); })) hosts.push(h);
      });
    });
    if (!hosts.length) return;
    busy = true;
    try {
      var cart = await (await fetch('/cart.js')).json();
      var sig = cart.items.map(function (i) { return i.key + ':' + i.quantity; }).join('|') + '#' + cart.total_price;
      var missing = hosts.some(function (h) { return cart.item_count && !h.querySelector('[data-posh-offer]'); });
      if (!force && sig === lastSig && !missing) return;
      lastSig = sig;
      injectStyle();
      for (var i = 0; i < hosts.length; i++) {
        var h = hosts[i];
        h.querySelectorAll('[data-posh-offer]').forEach(function (o) { o.remove(); });
        var banner = await buildBanner(cart);
        if (!banner) continue;
        var slot = slotFor(h);
        slot.insertBefore(banner, slot.firstChild);
      }
    } catch (e) {
    } finally {
      busy = false;
    }
  }

  function run() { groupBundles(); fixBundlePerPiece(); placeEta(); refreshOffer(false); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  var pending = false;
  new MutationObserver(function (muts) {
    var ours = muts.every(function (m) { return m.target.closest && (m.target.closest('[data-posh-offer]') || m.target.closest('[data-posh-eta]')); });
    if (ours || pending) return;
    pending = true;
    setTimeout(function () { pending = false; run(); }, 400);
  }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('cart:update', function (e) {
    if (e.detail && e.detail.sourceId === 'posh') return;
    setTimeout(function () { refreshOffer(true); }, 500);
  });
  document.addEventListener('shopify:section:load', run);
})();
